import { render, staticRenderFns } from "./FeedConsumptionPerBird.vue?vue&type=template&id=527c2d7c&scoped=true"
import script from "./FeedConsumptionPerBird.vue?vue&type=script&lang=js"
export * from "./FeedConsumptionPerBird.vue?vue&type=script&lang=js"
import style0 from "./FeedConsumptionPerBird.vue?vue&type=style&index=0&id=527c2d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527c2d7c",
  null
  
)

export default component.exports